export const LIST_PRODUCTS = 'LIST_PRODUCTS'

export const SET_SERVICE_ATTRIBUTES = 'SET_SERVICE_ATTRIBUTES'

export const GET_FIND_PRODUCT = 'GET_FIND_PRODUCT'